'use strict';

module.exports = bail;

function bail(err) {
  if (err) {
    throw err;
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/bail/index.js
// module id = 163
// module chunks = 110308036455227 195351340454287